export default "__VITE_ASSET__04efc954__"